import { Routes } from '@angular/router';
import { usuarioLogadoGuard } from './core/guards/usuario-logado.guard';
import { mensagemPendenteGuard } from './core/guards/mensagem-pendente.guard';
import { semPesquisaPendenteGuard } from './core/guards/sem-pesquisa-pendente.guard';
import { semQuestionarioPendenteGuard } from './core/guards/sem-questionario-pendente.guard';
import { somenteAlunoEadGuard } from './core/guards/somente-aluno-ead.guard';
import { somenteCadastroPendenteGuard } from './core/guards/somente-cadastro-pendente.guard';
import { mensagemPendenteResolver } from './core/resolvers/mensagem-pendente.resolver';
import { beneficiosUnipAtivoGuard } from './core/guards/beneficios-unip-ativo.guard';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'token/:token',
    loadComponent: () => import('./components/login-token/login-token.component').then(m => m.LoginTokenComponent)
  },
  {
    path: 'acesso-objetivo',
    loadComponent: () => import('./components/acesso-objetivo/acesso-objetivo.component').then(m => m.AcessoObjetivoComponent)
  },
  {
    path: 'senha/solicitar',
    loadComponent: () => import('./components/senha/solicitar.component').then(m => m.SolicitarComponent)
  },
  {
    path: 'senha/opcoes-redefinir',
    loadComponent: () => import('./components/senha/opcoes-redefinir.component').then(m => m.OpcoesRedefinirComponent)
  },
  {
    path: 'senha/redefinir',
    loadComponent: () => import('./components/senha/redefinir.component').then(m => m.RedefinirComponent),
    canActivate: [usuarioLogadoGuard]
  },
  {
    path: 'aulas-ao-vivo',
    loadComponent: () => import('./components/aulas-ao-vivo/aulas-ao-vivo.component').then(m => m.AulasAoVivoComponent),
    canActivate: [usuarioLogadoGuard]
  },
  { path: 'index.aspx', redirectTo: '' },
  {
    path: 'mensagem/:idMensagem',
    loadComponent: () => import('./components/mensagem/mensagem.component').then(m => m.MensagemComponent),
    canActivate: [usuarioLogadoGuard],
    resolve: { mensagem: mensagemPendenteResolver },
    runGuardsAndResolvers: 'pathParamsChange'
  },
  {
    path: 'sistemas',
    loadComponent: () => import('./components/central/central.component').then(m => m.CentralComponent),
    canActivate: [usuarioLogadoGuard],
    canActivateChild: [usuarioLogadoGuard, mensagemPendenteGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./components/central/lista-sistemas/lista-sistemas.component').then(m => m.ListaSistemasComponent),
        canActivate: [semPesquisaPendenteGuard, semQuestionarioPendenteGuard]
      },
      {
        path: 'acesso/:idSistema',
        loadComponent: () => import('./components/central/acesso/acesso.component').then(m => m.AcessoComponent),
        canActivate: [semPesquisaPendenteGuard, semQuestionarioPendenteGuard]
      },
      {
        path: 'cadastro',
        loadComponent: () => import('./components/cadastro/cadastro.component').then(m => m.CadastroComponent),
        canActivate: [somenteAlunoEadGuard, somenteCadastroPendenteGuard]
      },
      {
        path: 'aulas-ao-vivo',
        loadComponent: () => import('./components/aulas-ao-vivo/aulas-ao-vivo.component').then(m => m.AulasAoVivoComponent),
        canActivate: [semPesquisaPendenteGuard, semQuestionarioPendenteGuard],
        data: { dentroDaCentral: true }
      },
      {
        path: 'pesquisa',
        loadComponent: () => import('./components/pesquisa/pesquisa.component').then(m => m.PesquisaComponent)
      },
      {
        path: 'questionarios',
        loadComponent: () => import('./components/questionarios/questionarios.component').then(m => m.QuestionariosComponent)
      },
      {
        path: 'beneficios',
        canMatch: [beneficiosUnipAtivoGuard],
        loadChildren: () => import('./features/beneficios/beneficios.routes').then(m => m.BENEFICIOS_ROUTES),
        canActivate: [semPesquisaPendenteGuard, semQuestionarioPendenteGuard]
      }
    ]
  },
  {
    path: 'senha',
    loadComponent: () => import('./components/central/central.component').then(m => m.CentralComponent),
    canActivate: [usuarioLogadoGuard],
    canActivateChild: [usuarioLogadoGuard],
    children: [
      {
        path: 'alterar',
        loadComponent: () => import('./components/central/alterar-senha/alterar-senha.component').then(m => m.AlterarSenhaComponent)
      },
      {
        path: 'alterar-e-mail',
        loadComponent: () => import('./components/central/alterar-senha-email-institucional/alterar-senha-email-institucional.component').then(m => m.AlterarSenhaEmailInstitucionalComponent)
      }
    ]
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES)
  }
];
